export class ImportUser {
    username: string = '';
    surname: string = '';
    givenname: string = '';
    birthyear: string = '';
    groups: string[] = [];
}
